import autoComplete from "@tarekraafat/autocomplete.js";

var module = {
	autoCompleteJS: null, // store reference globally

	init: function () {
		this.autoCompleteJS = new autoComplete({
			selector: ".js-tool-searchbox",
			placeHolder: "Search for tools",
			data: {
				src: toolNames,
				cache: true,
			},
			resultsList: {
				element: (list, data) => {
					if (!data.results.length) {
						const message = document.createElement("div");
						message.setAttribute("class", "no_result");
						message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
						list.prepend(message);
					}
				},
				noResults: true,
			},
			resultItem: {
				tag: "li",
				highlight: true,
				submit: true,
			},
			events: {
				input: {
					input: (event) => {
						const query = event.target.value.toLowerCase();

						document.querySelectorAll(".c-tools-listing-group__item").forEach((el) => {
							const nameEl = el.querySelector(".c-tools-listing-group__item-name");
							const name = nameEl ? nameEl.textContent.toLowerCase() : "";
							const matches = name.includes(query);
							el.style.display = matches || query === "" ? "" : "none";
						});

						document.querySelectorAll(".c-tools-listing-group").forEach((group) => {
							const hasVisibleItem = Array.from(group.querySelectorAll(".c-tools-listing-group__item"))
								.some(item => item.style.display !== "none");
							group.style.display = hasVisibleItem ? "" : "none";
						});
					},
					focus: (event) => {
						// Optional: show all on focus
					},
					// Uncomment if you want to filter by exact match on selection
					// selection: (event) => {
					//     const selection = event.detail.selection.value.toLowerCase();
					//     ...
					//     module.autoCompleteJS.input.value = selection;
					// }
				}
			}
		});

		this._bindEvents();
	},

	_bindEvents: function () {
		this.autoCompleteJS.input.addEventListener("keydown", (e) => {
			if (e.key === "Escape") {
				this._resetFilter();
			}
		});
	},

	_resetFilter: function () {
		document.querySelectorAll(".c-tools-listing-group__item").forEach(el => {
			el.style.display = "";
		});

		document.querySelectorAll(".c-tools-listing-group").forEach(group => {
			group.style.display = "";
		});

		this.autoCompleteJS.input.value = "";
	}
};

export { module as ToolSearch };
